import { ReactSVG } from 'react-svg';
import React from 'react';
import styled from 'styled-components';

interface Props {
    active?: boolean;
    size?: number;
}

const Icon = styled.div<Props>`
    cursor: pointer;
    padding: 0.5em;
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${(props) => (props.size === 0 ? '16px' : '24px')};
    height: ${(props) => (props.size === 0 ? '16px' : '24px')};
    fill: ${(props) => (props.active ? '#66C3D0' : '#000')};
    &:hover * {
        fill: #66c3d0;
    }
    & div {
        display: flex;
        align-items: center;
    }
`;

const IconStrike = styled.div<Props>`
    cursor: pointer;
    padding: 0.5em;
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${(props) => (props.size === 0 ? '16px' : '24px')};
    height: ${(props) => (props.size === 0 ? '16px' : '24px')};
    stroke: ${(props) => (props.active ? '#66C3D0' : '#000')};
    &:hover * {
        stroke: #66c3d0;
    }
    & div {
        display: flex;
        align-items: center;
    }
`;

export const PropertiesIcon: React.FC<{ onClick?: () => void; titel?: string; active?: boolean }> = ({
    onClick,
    titel,
    active
}) => {
    return (
        <Icon size={0} title={titel} onClick={onClick} active={active}>
            <ReactSVG src="./ixyber/vision/static/images/properties_icon.svg" />
        </Icon>
    );
};

export const EventsIcon: React.FC<{ onClick?: () => void; titel?: string; active?: boolean }> = ({
    onClick,
    titel,
    active
}) => {
    return (
        <Icon size={0} title={titel} onClick={onClick} active={active}>
            <ReactSVG src="./ixyber/vision/static/images/events_icon.svg" />
        </Icon>
    );
};

export const FunctionIcon: React.FC<{ onClick?: () => void; titel?: string; active?: boolean }> = ({
    onClick,
    titel,
    active
}) => {
    return (
        <IconStrike size={0} title={titel} onClick={onClick} active={active}>
            <ReactSVG src="./ixyber/vision/static/images/function_icon.svg" />
        </IconStrike>
    );
};

export const CloseIcon: React.FC<{ onClick?: () => void; titel?: string }> = ({ onClick, titel }) => {
    return (
        <Icon size={0} title={titel} onClick={onClick}>
            <ReactSVG src="./ixyber/vision/static/images/close.svg" />
        </Icon>
    );
};
